import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import useBrandProvider from '@hooks/useBrandProvider'
import useBrandProviders from '@hooks/useBrandProviders'

import BrandProvider from './BrandProvider'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'provider_title',
      label: 'Filter by Title or ID',
    },
  ]
}

const BrandProviders = (props :{ brandId: number }) => {
  const { brandId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const brandProvidersPayload = useBrandProviders({
    filters: { brand_id: brandId, ...pageFilters },
    performHttpRequests: !!brandId,
    requestOptions: { include_brand_provider_provider: true },
    sortKey: 'provider',
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredBrandProviders,
    filteredBrandProvidersCount,
    hasFilteredBrandProviders,
    loading,
  } = brandProvidersPayload

  const {
    callbacks: { addBrandProvider },
  } = useBrandProvider({ brand_id: brandId })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Providers"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && !hasFilteredBrandProviders && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Providers present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please adjust your filters or assign a Provider.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && hasFilteredBrandProviders && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection flexDirection="column" maxHeight={600}>
          {filteredBrandProviders.map(brandProvider => (
            <BrandProvider
              brandProvider={brandProvider}
              key={brandProvider.id}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredBrandProvidersCount}
        loading={loading}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => addBrandProvider()}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Providers
        </Button>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

export default BrandProviders
